import { Component, Input } from '@angular/core';
import { IFatura } from 'src/app/interfaces';

@Component({
  selector: 'app-item-financeiro-mobile',
  templateUrl: './item-financeiro-mobile.component.html',
  styleUrls: ['./item-financeiro-mobile.component.scss']
})
export class ItemFinanceiroMobileComponent {
  @Input() financeiro: IFatura;

  isFinanceiroCollapsed = true;

  constructor() {}
}
